import * as React from "react";
import MotwLogicServer from "source/app/services/External/LogicServer/MotwLogicServer";
import { IDailySpendState } from "./IDailySpendState";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import { TRenderable } from "source/app/presentation/Shared/SharedTypes";

export function DailySpend() {
    const [state, setState] = React.useState<IDailySpendState>({
        data: [],
    });

    React.useEffect(() => {
        MotwLogicServer.GetDailySpendRecordsAsync().then((data) =>
            setState({ ...state, data })
        );
    }, []);

    return (
        <div className={dailySpendGridClassName}>
            <DisplayHeaderRow />
            {state.data.map((dailySpendRow, index) => (
                <React.Fragment key={dailySpendRow.id || index}>
                    <div>{dailySpendRow.transaction_date}</div>
                    <div style={{ color: `yellowgreen` }}>
                        +C$ {dailySpendRow.credit_money}
                    </div>
                    <div style={{ color: `yellowgreen` }}>
                        C$ {dailySpendRow.balance}
                    </div>
                    {/* <div>{dailySpendRow.expense_name}</div> */}
                    <div style={{ color: `coral` }}>
                        -C$ {dailySpendRow.expense_amount}
                    </div>
                    {/* <div>{dailySpendRow.adjustment ? "Yes" : "No"} </div> */}
                </React.Fragment>
            ))}
        </div>
    );
}

function DisplayHeaderRow() {
    return (
        <>
            <HeaderCell>Transaction Date</HeaderCell>
            <HeaderCell>Credit Money</HeaderCell>
            <HeaderCell>Balance</HeaderCell>
            {/* <HeaderCell>Expense Name</HeaderCell> */}
            <HeaderCell>Expense Amount</HeaderCell>
            {/* <HeaderCell>Adjustment</HeaderCell> */}
        </>
    );
}

const HeaderCell = ({ children }: { children: TRenderable }) => (
    <div
        className={StyleClassAuto({
            background: `black`,
            borderRadius: "3px",
            color: `white`,
        })}
    >
        {children}
    </div>
);

const dailySpendGridClassName = StyleClassAuto({
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)", // Adjust the number of columns as needed
    gridGap: "10px", // Adjust the gap between grid items
    textAlign: `center`,
    margin: `10px 20px`,
});
